import { createStyles, makeStyles } from '@material-ui/styles';
import { grey } from '../../theme/colors';
import palette from '../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: 'available',
      gap: '20px',
      padding: '20px'
    },
    pageInfoText: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    },
    pageTitle: {
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '24px',
      lineHeight: '29px',
      color: grey.lighter
    },
    pageDesc: {
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '20px',
      color: grey.lighter
    },
    quizListWrapper: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: '20px',
      '@media (max-width: 768px)': {
        justifyContent: 'center'
      }
    },
    noQuizzHead: {
      fontWeight: 600,
      color: palette.text.primary
    },
    noQuizzContent: {
      background: palette.background.underBox,
      padding: '5px',
      borderRadius: palette.borderRadius.default,
      display: 'flex',
      gap: '5px',
      flexDirection: 'column',
      flexWrap: 'wrap',
      '@media (max-width: 360px)': {
        background: palette.background.paper,
        padding: 0
      }
    },
    quizCard: {
      width: 'max-content',
      '@media (max-width: 375px)': {
        width: '100%'
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
